<script>
	import UAParser from "ua-parser-js";
	let parser2 = new UAParser();
	let unredactedBrowser = parser2.getBrowser().name;
	let ua = parser2.getUA();
	let detectedBrowser = parser2.getBrowser().name
			.toLowerCase()
      .normalize("NFD")
      .replace(/ /g, "")
      .replace(/[^\w\s]/gi, "")
      .replace(/[\u0300-\u036f]/g, "");
</script>

<div class="mx-2">
	<h1 class="text-xl mb-2 font-bold">
		Over BlueToolkit
	</h1>

	<h2 class="font-bold mt-2">Wat is dit?</h2>
	<p>BT (BlueToolkit) is een webbased tool om wat handmatig intensieve klusjes makkelijker te maken. Het idee erachter is, dat als je per dag 5-10 minuten kan besparen; dan kan dat voor veel mensen heel veel tijd schelen. En dus meer tijd op straat.</p>

	<h2 class="font-bold mt-2">BlueToolkit werkt niet met SecureWeb?!</h2>
	<p>BT maakt gebruik van bepaalde functies (oa. PDF-download van concept pv's) die volgens internetstandaarden mogelijk zijn. SecureWeb draait binnen een beveiligde omgeving en ondersteunt deze functies blijkbaar niet. Jammer. Gebruik dus een browser zoals <b>Google Chrome op MEOS</b> of <b>Samsung Internet/DuckDuckGo op nieuwe MEOS</b> (te downloaden via Store). Via BU/bestandsuitwisseling van de baas, kun je de gedownloade PDF's uploaden en weer downloaden binnen Citrix/Desktop.  (huidige browser: {detectedBrowser})</p>

	<h2 class="font-bold mt-2">Hoe zit het met data?</h2>
	<p>BT is zo opgezet dat het clientside werkt, voor technici: alles draait in de browser, geen backend, geen server. Dus data die je inklopt, zit alleen op je lokale machine.</p>

	<h2 class="font-bold mt-2">Wie heeft dit gebouwd?</h2>
	<p>Deze tool is gebouwd (en nog steeds in ontwikkeling) door HGL75096. Blok voor intimi. <a class="underline decoration-dashed" href="mailto:hgl75096@politie.local?subject=feedback op bluetoolkit">Mail voor suggesties of feedback</a>; of bugs.</p>

	<h2 class="font-bold mt-2">Roadmap?</h2>
	<p>In willekeurige volgorde:</p>
	<ul class="list-disc">
		<li>Concept-PV; template gebruiken als start, basis verhoor mishandeling/diefstal/vernieling/inbraak woning</li>
		<li>DyCo; stappen, scenarios, mogelijkheden, signalen, aanwijzingen, standaardteksten, genereren verhoor</li>
		<li>Suggesties welkom</li>
	</ul>

	<h2 class="font-bold mt-2">Laatste releases:</h2>
	<ul class="list-disc">
		<li>02-01-23: Toevoegen ADR cilinders, overige updates aan ADR-tool</li>
		<li>27-12-22: Basis afstandsverklaring toegevoegd</li>
		<li>27-11-22: Fotogenerator tweaks (verplaatsen, PL-code), 1-click selecteren van variabelen, markeer variabelen</li>
		<li>11-10-22: Fotogenerator aangepast, eigen kopteksten, grote afbeeldingen, centreren</li>
		<li>06-10-22: Eerste versie fotobladgenerator</li>
		<li>28-09-22: Betere navigatie, directe links naar tools</li>
		<li>15-06-22: Verschillende verhoren, aangiftes, getuigeverklaringen toegevoegd; browserherkenning + foutmelding</li>
		<li>03-02-22: Kleine wijzigingen, tekst, kleine verbeteringen interface, PV ADR-lachgas verhoor toegevoegd, nu ook bereikbaar via ADR-lachgas</li>
		<li>27-01-22: Leest lijst met sjabloon concept pv's, parsed, prefills, redirect naar concept pv</li>
		<li>26-01-22: ADR-lachgas tool toegevoegd, overzicht ADR overtredingen, invullen controledata, genereren controle-overzicht + download</li>
		<li>19-01-22: tekstuele aanpassingen, inplakken teksten in verklaring geschoond, hernoemen objecten</li>
		<li>18-01-22: naam ondertekenaar toegevoegd bij handtekening, PV van 1 regel genereren, statusbericht aangepast, knoptekst genereren variabel, geef naam ondertekenaar weer als deze ingevuld is, voorbereide/geprepareerde verklaring</li>
		<li>17-01-22: statische info toegevoegd aan ADR, tijdelijke pagina toegevoegd, startpagina aangepast</li>
	</ul>
</div>

<style>

</style>